import { render } from "./TabContent.vue?vue&type=template&id=1ea973fc"
import script from "./TabContent.vue?vue&type=script&lang=js"
export * from "./TabContent.vue?vue&type=script&lang=js"

import exportComponent from "/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__